// Module
var code = "<template>\n  <require from=\"../wash-matrix-view\"></require>\n\n  <wash-matrix-view erp-system-id.bind=\"5\"></wash-matrix-view>\n</template>";
// Exports
export default code;